module.exports = __webpack_public_path__ + "media/images/emblems/Sachseln-coat_of_arms-922bb7c04a8e63ba02d4552447a5cd67.svg";